import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    const controlNavbar = () => {
      if (typeof window !== 'undefined') {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY && currentScrollY > 100) {
          // Scrolling down
          setIsVisible(false);
        } else {
          // Scrolling up
          setIsVisible(true);
        }

        setLastScrollY(currentScrollY);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', controlNavbar);
      return () => {
        window.removeEventListener('scroll', controlNavbar);
      };
    }
  }, [lastScrollY]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-between h-20 px-6 md:px-12 bg-canvas transition-transform duration-500 ease-in-out ${isVisible ? 'translate-y-0' : '-translate-y-full'
          }`}
        role="navigation"
        aria-label="Main navigation"
      >
        {/* Left: Logo */}
        <Link
          to="/"
          className="text-xl font-semibold tracking-tight text-text-primary"
          aria-label="SilentLabs Home"
        >
          SilentLabs
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8 group">
          <Link
            to="/products"
            className={`nav-link text-base font-medium tracking-wide transition-opacity text-text-primary group-hover:opacity-60 hover:!opacity-100 ${isActive('/products') ? 'underline underline-offset-4 decoration-1' : ''}`}
          >
            Products
          </Link>
          <Link
            to="/research"
            className={`nav-link text-base font-medium tracking-wide transition-opacity text-text-primary group-hover:opacity-60 hover:!opacity-100 ${isActive('/research') ? 'underline underline-offset-4 decoration-1' : ''}`}
          >
            Research
          </Link>
          <Link
            to="/about"
            className={`nav-link text-base font-medium tracking-wide transition-opacity text-text-primary group-hover:opacity-60 hover:!opacity-100 ${isActive('/about') ? 'underline underline-offset-4 decoration-1' : ''}`}
          >
            About
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden z-50 p-2 -mr-2 text-text-primary focus:outline-none"
          aria-label="Toggle mobile menu"
          aria-expanded={isMobileMenuOpen}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            {isMobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 z-40 md:hidden bg-canvas safe-top pt-20"
          role="dialog"
          aria-modal="true"
          aria-label="Mobile navigation menu"
        >
          <div className="flex flex-col px-6 space-y-6 pt-12">
            <Link to="/" className="text-body font-medium text-text-primary">
              Home
            </Link>
            <Link to="/research" className="text-body font-medium text-text-primary">
              Research
            </Link>
            <Link to="/about" className="text-body font-medium text-text-primary">
              About
            </Link>
            <Link to="/products" className="text-body font-medium text-text-primary">
              Products
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
